export const isWeixin = /micromessenger/i.test(navigator.userAgent);
